import React from "react";
import "../../styles/Venue.scss";
import smxImg from "../../components/assets/smx.jpg";

const Venue: React.FC = () => {
  return (
    <section id="venue" className="venue-section" style={{ backgroundImage: `url(${smxImg})` }}>
      <div className="overlay"></div>
      <div className="venue-content">
        <h2 className="venue-title-left">SMX Convention Center</h2>

        <div className="venue-title-right">
          <h1>APLIC 2027</h1>
          <h1>Venue</h1>
          <h3>A World-Class Venue for a World-Class Congress</h3>
        </div>

        <div className="venue-buttons-text">
          <button className="register-btn" onClick={() => window.open("https://aplic2027.gottit.io/", "_blank")}>
            <span className="register-btn-text">Register Now</span>
          </button>

          <div className="venue-text-row">
            <div className="venue-text">
              <p>
                The 21st Asia Pacific Life Insurance Congress (APLIC) 2027 will be held at the SMX Convention Center Manila, the Philippines' premier venue for international conferences, exhibitions, and large-scale events.
              </p>
            </div>

            <div className="venue-text">
              <p>
                With over 21,000 square meters of flexible event space, SMX Convention Center is fully equipped to host thousands of delegates in comfort and style.
              </p>
            </div>

            <button className="read-more-btn" onClick={() => window.location.href = "/venue"}>Read More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Venue;
